import React, {createElement, useContext, useEffect, useMemo, useRef, useState} from "react";
import {
    BrowserView
} from "react-device-detect";
import {history} from "../../../history";
import {PhoneCall, Search, Speaker} from "react-feather";
import {Button, Col, NavLink, Row} from "reactstrap";
import logo1 from "../../../assets/images/logo/color-logo.png";
import {DETAILS} from "@assets/data/config/storeConfig";
import Navbar from "./Menus/MobileMenuRender/Navbar";
import {BiUser} from 'react-icons/bi'
import Menu from "./Menus/Menu";
import {useSelector} from "react-redux";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Category} from "../../../utility/context/ProductCategoryProvider";
import Img from "../../../assets/images/logo/color-logo.png";
import Login from "../../../views/web/authentication/Login";
import {RiSearch2Line} from 'react-icons/ri'
import {FaUser} from 'react-icons/fa'
import {BsBasketFill} from 'react-icons/bs'
import {AiFillHome, AiOutlineClose, AiOutlineInstagram, AiOutlinePhone} from 'react-icons/ai'
import {BsTelephoneFill} from 'react-icons/bs'
import {AiOutlineArrowUp} from 'react-icons/ai'
import Product from "../home/Product";
import ScrollTopMenu from "./Menus/ScrollTopMenu";
import GetRequest from "@configs/request/get-request";
import {FiSmartphone} from "react-icons/fi";
import {PiInstagramLogoLight} from "react-icons/pi";
import {HiSpeakerphone} from "react-icons/hi";
import scrollWindowTop from "../../../configs/utils/scrollWindowTop";
import linelogo from "../../../assets/images/logo/lineLogo.png"

const Header = ({data}) => {
    const [position, setPosition] = useState(0);
    const navigate = useNavigate()
    const UI = useSelector(state => state.UI);
    const Categories = useContext(Category)
    const auth = useSelector(state => state.auth);
    const [searchTerm, setSearchTerm] = useState("")
    const [is_login, setLogin] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)
    const [URL, setURL] = useState("/general/services/search")
    const [active, setActive] = useState("")
    const {pathname} = useLocation();
    const [searchValue, setSearchValue] = useState("")
    const [products, setProducts] = useState(null)
    let [searchParams, setSearchParams] = useSearchParams();
    const searchValueParams = searchParams.get("s") ?? "";
    const [selectedCategory, setSelectedCategory] = useState('');
    const [urlProducts, setUrlProducts] = useState('/general/products')
    const [is_loading, setLoading] = useState(false)
    const [form, setForm] = useState(0)
    const [to, setTo] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [searchClass , setSearchClass] = useState(false)
    const [breaking_news , setBreaking_news] = useState("")

    useEffect(() => {
        setLogin(false);
        // getProducts();
        category();
    }, [URL] );

    // useEffect(() => {
    //     setSearchTerm(searchValueParams)
    // }, [searchValueParams])

    // useEffect(() => {
    //     setSearchTerm(searchValue)
    // }, [searchValue])


    const category = () => {
        if (selectedCategory) {
            let n = pathname.lastIndexOf('/');
            let SCategory = decodeURIComponent(pathname.substring(n + 1));
            let baseUrl = "/products";
            setUrlProducts(`${baseUrl}?sort=${SCategory}`)
        }
    }
    const activePage = (event) => {
        setActive(event.target.id)
    }


    // const getProducts = () => {
    //     setLoading(true);
    //     GetRequest(urlProducts, {
    //         page: currentPage
    //     }).then((response) => {
    //         if (response) {
    //             let result = response.data;
    //             if (result.ok) {
    //                 setProducts(result.data.data);
    //                 setForm(result.data.from);
    //                 setTo(result.data.to);
    //                 //setCurrentPage(result.data.articles.current_page);
    //                 setTotalPages(result.data.last_page);
    //                 window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    //                 setLoading(false);
    //             }
    //         }
    //     })
    // }

    const handleSearchTermChange = (e) => {
        const searchTerm = e.target.value;
        setSearchTerm(searchTerm);
        setCurrentPage(1);
        setURL(`/general/services/search?s=${searchTerm}`);
        // setSearchParams({s: searchTerm});
    };

    const handleProductClick = (product) => {
        navigate(`/product/${product.id}`);
    };
    const openSearchHandler = ()=>{
        setSearchClass(!searchClass)
    }
    const handelSearch = (e) => {
        e.preventDefault();
        navigate("/search?s=" + searchTerm);
        setSearchTerm("")
    }

    const handleKeyDown = (e) => {
        if(e.key === 'Enter'){
            handelSearch(e)
        }
    }

    const searchHandler = (e) => {
        setSearchValue(e.target.value);
    }


    const logo_mobile = <>
        <NavLink to="/" className='d-flex align-items-center justify-content-center '>
            <img src={logo1} alt="logo" width="60px"/>
        </NavLink>
    </>;

    return (
        <>
            {/*<div className='d-flex align-items-center justify-content-center breaking_news ' >
                {UI.breaking_news}
            </div>*/}
            <div className="header  flex-column  m-auto ">
                <div className='container-custom '>
                    <div className='phone-bottom-header'>

                        <div>
                            <div id='div-container' className={pathname === '/' ? 'activeColor' : ''} onClick={() => navigate('/')}>
                                <AiFillHome/>
                                <p className={pathname === '/' ? 'activeColor' : ''}>صفحه اصلی </p>
                            </div>
                        </div>

                        {/*<div >*/}
                        {/*    /!*<span><RiSearch2Line/></span>*!/*/}
                        {/*    /!*<p> جستجو</p>*!/*/}
                        {/*    <div id='div-container'  className={pathname === '/products' ? 'activeColor' : ''} onClick={() => navigate('/products')}>*/}
                        {/*        <RiSearch2Line/>*/}
                        {/*        <p> جستجو </p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div>
                            <div id='div-container'>
                                <a href='https://instagram.com/farivar_hesab'>
                                    <AiOutlineInstagram/>
                                    <p> اینستاگرام </p>
                                </a>
                            </div>
                        </div>
                        <div>
                            <div id='div-container'  className={pathname === '/contact-us' ? 'activeColor' : ''} onClick={() => navigate('/contact-us')}>
                                <AiOutlinePhone/>
                                <p> تماس با ما </p>
                            </div>
                        </div>


                            <div className='scroll-to-top' onClick={scrollWindowTop}>
                                <a><AiOutlineArrowUp/></a>
                            </div>

                    </div>
                    <div className="phone d-none " id='phone-header'>
                        <div className={`header-mobile-main ${position >= 0.03 ? ' scroll-fixed bg-white' : ''}`}>
                            <div>
                                <Navbar category={Categories}
                                        logo={logo_mobile}
                                    //toggleModal={toggleModal}
                                />
                            </div>
                            <div>
                                <img src={logo1} width={30} alt='logo' />
                            </div>
                            <div className='d-flex call-box'>
                                <div className='px-1 '>
                                    <h3>
                                        <a href={`tel:09372639959 `} >
                                            <span><FiSmartphone/></span>
                                        </a>
                                    </h3>
                                </div>
                                <div className='px-1 border-left'>
                                    <h3>
                                        <a href={`tel:02634316422 `}>
                                          <span className='text-dark'>
                                               <span><AiOutlinePhone /></span>
                                          </span>
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="Desktop  container-fluid w-100">
                    <div className="header-main justify-content-between">

                        <div className='d-flex align-items-center'>
                            <div className={'mx-1'}>
                                <img className='logo-header' src={linelogo} width={130}/>
                            </div>
                            <Menu data={Categories}/>
                        </div>
                        <div className='left-bar '>
                            <div className="d-flex align-items-center justify-content-center ">
                                <button type="button" className="btn search-bar">
                                    <div className={searchClass === false ? "svg-input" : 'd-none'}  onClick={openSearchHandler}>
                                        <RiSearch2Line size={24} />
                                    </div>
                                    <input
                                        className={searchClass === true ? "search-Input shadow p-1 rounded-lg d-flex" : 'd-none'}
                                        placeholder="جستجو کنید"
                                        onChange={handleSearchTermChange}
                                        onKeyDown={handleKeyDown}
                                        type="search"
                                        name="search"
                                        value={searchTerm}
                                    />
                                    <div className={searchClass === true ? "svg-input" : 'd-none'}   onClick={openSearchHandler}>
                                        <AiOutlineClose/>
                                    </div>
                                </button>
                            </div>
                            <div className='phone-header-top d-flex align-items-center justify-content-center'>
                                <div className='px-1'>
                                    <h3 className='mb-0'>
                                        <a href={`tel:09372639959 `} >
                                            <span><FiSmartphone/></span>
                                            <span className='text-dark'>{DETAILS.phones[2]}</span>
                                        </a>
                                    </h3>
                                </div>
                                <div className='px-1'>
                                    <h3 className='mb-0'>
                                        <a href={`tel:02634316422 `}>
                                          <span className='text-dark'>
                                               <span><AiOutlinePhone /></span>
                                         <span className='text-dark'>{DETAILS.phones[0]}</span>
                                          </span>
                                        </a>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*{LoginModal}*/}

            </div>

        </>
    );
}

export default Header;



